function apiOrigin() {
  const raw = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || '';
  return String(raw).trim().replace(/\/+$/, '');
}

/** Same-origin path when no env is set (dev proxy); otherwise absolute API URL. */
export function apiUrl(path) {
  const p = typeof path === 'string' && path.startsWith('/') ? path : `/${path || ''}`;
  const o = apiOrigin();
  return o ? `${o}${p}` : p;
}
